import { Link } from "react-router-dom";
import { Twitter, Linkedin, Facebook, Instagram, ExternalLink } from "lucide-react";

export function Footer() {
  const currentYear = new Date().getFullYear();
  
  const footerLinks = [
    {
      title: "Domains",
      links: [
        { name: "Domain Search", href: "/" },
        { name: "Domain Transfer", href: "/pricing" },
        { name: "Domain Pricing", href: "/pricing" },
        { name: "Whois Lookup", href: "/pricing" },
      ],
    },
    {
      title: "Products",
      links: [
        { name: "Web Hosting", href: "/pricing" },
        { name: "WordPress Hosting", href: "/pricing" },
        { name: "Email Hosting", href: "/pricing" },
        { name: "SSL Certificates", href: "/pricing" },
      ],
    },
    {
      title: "Company",
      links: [
        { name: "About Us", href: "/about" },
        { name: "Contact", href: "/contact" },
        { name: "Careers", href: "/about" },
        { name: "Blog", href: "/about" },
      ],
    },
    {
      title: "Support",
      links: [
        { name: "Help Center", href: "/contact" },
        { name: "System Status", href: "/contact" },
        { name: "Submit Ticket", href: "/contact" },
        { name: "Contact Us", href: "/contact" },
      ],
    },
  ];

  const socialLinks = [
    { name: "Twitter", icon: Twitter, href: "https://twitter.com" },
    { name: "LinkedIn", icon: Linkedin, href: "https://linkedin.com" },
    { name: "Facebook", icon: Facebook, href: "https://facebook.com" },
    { name: "Instagram", icon: Instagram, href: "https://instagram.com" },
  ];

  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4 lg:gap-12">
          {footerLinks.map((category) => (
            <div key={category.title}>
              <h3 className="text-sm font-semibold text-foreground mb-4">{category.title}</h3>
              <ul className="space-y-2">
                {category.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-sm text-muted-foreground hover:text-primary transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 border-t border-border pt-8 flex flex-col sm:flex-row items-center justify-between">
          <div className="flex items-center mb-4 sm:mb-0">
            <Link to="/" className="flex items-center gap-2">
              <img
                src="https://storage.googleapis.com/fenado-ai-farm-public/generated/c14cb0ff-3c12-4652-b157-f3e307fc6c54.webp"
                alt="DomainDash Logo"
                className="h-8 w-8"
              />
              <span className="text-lg font-semibold text-foreground">DomainDash</span>
            </Link>
          </div>

          <div className="flex space-x-4 mb-4 sm:mb-0">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label={`Follow on ${social.name}`}
              >
                <social.icon className="h-5 w-5" />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-8 text-center text-sm text-muted-foreground">
          <p>© {currentYear} DomainDash. All rights reserved.</p>
          <div className="mt-2 flex justify-center space-x-6">
            <Link to="/about" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/about" className="hover:text-primary transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}